var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 1h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.43 23.57c6.509-6.509 17.061-6.509 23.57 0 6.509-6.509 17.061-6.509 23.57 0s6.509 17.062 0 23.57L43.48 67.232a4.92 4.92 0 0 1-6.958 0L16.43 47.14l-.225-.228c-6.283-6.525-6.208-16.909.225-23.342z",
    fill: "#3C57C0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 29.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DFE6FF",
    transform: "rotate(90 13 13)",
    x: 8,
    width: 10,
    height: 26,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5D1FF",
    x: 8,
    width: 10,
    height: 26,
    rx: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphHealth);
export default __webpack_public_path__ + "static/media/icons_graph_health.b5a55665f5a7c1fc70772f4632967a3b.svg";
export { ForwardRef as ReactComponent };